import { TableColumn } from '@fl/cmsch-fe-library';
import { ColumnHeader } from 'api/gen/ColumnHeader';
import { TFunction } from 'app/translations';
import { ManagementOtherSubjectsTableType } from '../../types/management-other-subjects';
const genDynamicColumns = (columns: Array<ColumnHeader>, t: TFunction<'admin'>, removeRoleForSubject: (roleId: string) => void, handleColumnOpenCreateModal: (roleId: string, roleName: string) => void): Array<TableColumn<ManagementOtherSubjectsTableType>> => columns.map(column => ({
  field: column.id.toString(),
  column: column.code,
  tooltip: column.code,
  type: 'dynamicReactNode',
  width: 180,
  align: 'center',
  specialHeaderOnClickActions: {
    create: handleColumnOpenCreateModal,
    delete: removeRoleForSubject,
    deleteConfirmTitle: t('confirmRemovingRoleForSubject', {
      role: column.code
    })
  }
}));

/**
 * Builds the other-subject-management table columns.
 *
 * @param dynamicColumns Role columns fetched from the API.
 * @param t Translation helper for admin strings.
 * @param tCommon Translation helper for common strings.
 * @param removeRoleForSubject Removes a role binding from the selected subject.
 * @param handleColumnOpenCreateModal Opens the binding creation modal for a role.
 * @returns Table columns for the other-subject-management table.
 */
export const managementOtherSubjectColumns = (dynamicColumns: Array<ColumnHeader>, t: TFunction<'admin'>, tCommon: TFunction<'common'>, removeRoleForSubject: (roleId: string) => void, handleColumnOpenCreateModal: (roleId: string, roleName: string) => void): Array<TableColumn<ManagementOtherSubjectsTableType>> => [{
  field: 'username',
  column: tCommon('firstName'),
  type: 'string',
  width: 180,
  locked: true,
  filterTypes: ['containsStringOr', {
    type: 'multiSelectStringOrEquals',
    subtype: 'bulkString'
  }, 'null']
}, ...genDynamicColumns(dynamicColumns, t, removeRoleForSubject, handleColumnOpenCreateModal)];